import { Badge, Field, Stack } from '@chakra-ui/react';

const VFormField = ({
  label,
  errorText = '',
  helperText,
  children,
  invalid,
  optional = false,
  orientation = undefined,
  ...props
}) => {
  const isHorizontal = orientation === 'horizontal';

  const content = (
    <>
      {children}
      {errorText && <Field.ErrorText>{errorText}</Field.ErrorText>}
      {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
    </>
  );

  return (
    <Field.Root
      invalid={invalid}
      orientation={orientation}
      alignItems={isHorizontal ? 'baseline' : undefined}
      {...props}
    >
      {label && (
        <Field.Label fontWeight="semibold" flex={isHorizontal ? '0 1 auto' : undefined}>
          {label}
          {optional && (
            <Field.RequiredIndicator
              fallback={
                <Badge size="xs" variant="surface">
                  Optional
                </Badge>
              }
            />
          )}
        </Field.Label>
      )}
      {isHorizontal ? <Stack gap="1.5">{content}</Stack> : content}
    </Field.Root>
  );
};

export default VFormField;
